export default "__VITE_ASSET__DhZMTj5L__"